<template>
    <v-card>
        <v-card-title class="font-weight-bold darkgrey--text">
            <div>Tambah Nama Interpretasi</div>

            <div class="mt-3">
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-text-field
                            v-model="data.name"
                            outlined
                            width="500"
                            placeholder="Nama Interpretasi"
                            style="font-weight: 500 !important"
                        ></v-text-field>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-btn
                            color="blew"
                            class="white--text ml-2"
                            style="margin-top: -30px"
                            x-large
                            depressed
                            width="60"
                            :loading="isLoading"
                            :disabled="!data.name"
                            @click="addPotentialIntelligences()"
                        >
                            {{ selectedRow.id ? "Edit" : "Tambah" }}
                        </v-btn>
                    </v-list-item-action>

                    <v-list-item-action>
                        <v-btn
                            v-if="selectedRow.id"
                            style="margin-top: -30px; margin-left: -10px"
                            x-large
                            depressed
                            :loading="isLoading"
                            @click="clearForm()"
                        >
                            Batal
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </div>
        </v-card-title>

        <v-card-text>
            <div>
                <v-list>
                    <v-list-item v-for="(data, i) in list_potential" :key="i">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ data.name }}
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-btn
                                fab
                                depressed
                                color="red"
                                x-small
                                dark
                                @click="confirmDeleteItem(data)"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-list-item-action>

                        <v-list-item-action>
                            <v-btn
                                fab
                                depressed
                                color="blew"
                                x-small
                                dark
                                style="margin-left: -5px"
                                @click="detailItem(data)"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </div>
        </v-card-text>

        <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn color="darkFade" text @click="$emit('close')"> Tutup </v-btn>
        </v-card-actions>

        <v-dialog v-model="confirmDialog" persistent max-width="490px">
            <v-card class="py-2">
                <v-card-title style="word-break: break-word !important">
                    Apakah anda akan menghapus nama interpretasi ini ?
                </v-card-title>

                <v-card-text>
                    Nama interpretasi {{ selectedRowDel.name }} ini akan
                    dihapus.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="confirmDialog = false">
                        Batal
                    </v-btn>
                    <v-btn
                        color="red"
                        dark
                        depressed
                        :loading="isLoadingForm"
                        @click="deleteItem()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import ambis_test from "../services/ambis_test";

export default {
    name: "dialog-potential",
    data: function () {
        return {
            isLoading: false,
            isLoadingForm: false,
            data: {
                name: "",
            },
            list_potential: [],
            confirmDialog: false,
            selectedRow: {},
            selectedRowDel: {},
        };
    },

    mounted() {
        this.getPotentialIntelligences();
    },

    methods: {
        getPotentialIntelligences() {
            var context = this;

            ambis_test.getPotentialIntelligences(function (result) {
                if (result.success) {
                    context.list_potential = result.data;
                }
            });
        },

        addPotentialIntelligences() {
            var context = this;
            var id = this.selectedRow.id;
            context.isLoading = true;

            if (!id) {
                ambis_test.addPotentialIntelligences(
                    this.data,
                    function (result) {
                        if (result.success) {
                            context.getPotentialIntelligences();

                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });

                            context.clearForm();
                            context.isLoading = false;
                        } else {
                            context.isLoading = false;
                        }
                    },
                );
            } else {
                ambis_test.editPotentialIntelligences(
                    id,
                    this.data,
                    function (result) {
                        if (result.success) {
                            context.getPotentialIntelligences();

                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });

                            context.clearForm();
                            context.isLoading = false;
                        } else {
                            context.isLoading = false;
                        }
                    },
                );
            }
        },

        confirmDeleteItem(val) {
            this.selectedRowDel = val;
            this.confirmDialog = true;
        },

        detailItem(val) {
            this.selectedRow = val;
            this.data.name = val.name;
        },

        deleteItem() {
            var context = this;
            const id = context.selectedRowDel.id;
            context.isLoadingForm = true;

            ambis_test.deletePotentialIntelligences(id, function (result) {
                if (result.success) {
                    context.isLoadingForm = false;
                    context.confirmDialog = false;
                    context.getPotentialIntelligences();

                    context.$store.commit("showAlert", {
                        message: `Berhasil Menghapus Data!`,
                        type: "success",
                    });
                } else {
                    context.isLoadingForm = false;
                    context.$store.commit("showAlert", {
                        message: `Gagal Menghapus Data!`,
                        type: "error",
                    });
                }
            });
        },

        clearForm() {
            this.data.name = "";
            this.data.id = "";
            this.selectedRow = {};
            this.selectedRowDel = {};
        },
    },
};
</script>



// WEBPACK FOOTER //
// DialogPotential.vue?f43bfc22